import { Avatar, Box, Link, Paper, styled, Typography } from '@mui/material';
import { globalColors } from './globalColorVariables';

export const StyledAvatar = styled(Avatar)({
  backgroundColor: 'rgba(230, 230, 230, 1)',
  color: 'rgba(0, 0, 0, 0.87)',
  fontSize: '16px',
  weight: 400,
  letterSpacing: '0,3px'
});

export const HeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%'
});

export const LeftHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '1rem 0rem',
  textDecoration: 'none',
  flex: '1 1 auto'
});

export const SearchContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '40%'
});

export const SearchInput = styled(Paper)({
  width: '100%',
  padding: '8px 12px',
  backgroundColor: globalColors.whiteColor,
  borderStyle: 'solid',
  borderWidth: '2px',
  borderColor: globalColors.lightGreyColor,
  borderRadius: '1.4rem'
});

export const LinkTypography = styled(Typography)({
  marginLeft: '1rem',
  marginRight: '1rem',
  fontSize: '16px',
  fontWeight: 500
});

export const InactiveLink = styled(Link)({
  color: 'rgba(0, 0, 0, 0.6)',
  textDecoration: 'none',
  '&:hover': {
    borderBottom: '1px solid #2864AC',
    paddingBottom: '5px'
  }
});

export const AccountMenuStyles = {
  marginLeft: '1rem',
  padding: '6px 15px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500
};
